import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "price-lpu-back align-self-start" },
    [
      !_setup.isMobile
        ? _c(
            VBtn,
            {
              staticClass:
                "branding-btn branding-btn--white rounded-20 text-none text-body-1 elevation-1",
              attrs: {
                href: _setup.lpuHref,
                depressed: "",
                height: "52",
                "data-qa": "lpu_page_price_back",
              },
            },
            [
              _c("span", {
                staticClass: "ui-icon-arrow-back mr-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(
                "\n    " + _vm._s(_setup.tStatic("Описание клиники")) + "\n  "
              ),
            ]
          )
        : _c(
            "a",
            {
              staticClass:
                "text-body-1 primary--text d-flex align-center text-decoration-none",
              attrs: { href: _setup.lpuHref, "data-qa": "lpu_page_price_back" },
            },
            [
              _c("span", {
                staticClass: "ui-icon-arrow-back mr-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_setup.tStatic("О клинике")))]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }